import React, {useState, useEffect} from 'react'
import firebase from "../../../../Config/firebase";
import {Link} from "react-router-dom";

const db = firebase.firestore()

const HistoryReplyCard = (props) => {

    const [review, setReview] = useState(false)
    const [isLoadedReview, setIsLoadedReview] = useState(false)
    const [path, setPath] = useState([])

    useEffect(() => {
        if (typeof props.data.fullPath !== 'undefined' && props.data.fullPath !== '') {
            let path = props.data.fullPath.split("/")
            setPath(path)
            getReview(path)
        }
    }, [props.data])

    const getReview = (path) => {
        if(Array.isArray(path)){
            if(path.length === 4){
                db
                    .collection('Post')
                    .doc(path[1])
                    .collection("Review")
                    .doc(path[3])
                    .get()
                    .then(doc => {
                        let data= {
                            ...doc.data(),
                            id: doc.id
                        }
                        setReview(data)
                        setIsLoadedReview(true)
                    })
                    .catch(err => console.log(err))
            }
            else  if(path.length === 6){
                db
                    .collection('Post')
                    .doc(path[1])
                    .collection("Review")
                    .doc(path[3])
                    .collection("Reply")
                    .doc(path[5])
                    .get()
                    .then(doc => {
                        let data= {
                            ...doc.data(),
                            id: doc.id
                        }
                        setReview(data)
                        setIsLoadedReview(true)
                    })
                    .catch(err => console.log(err))
            }
        }


    }

    if(isLoadedReview){
        return (
            <div>
                <Link to={'/Post/' + path[1]} >
                    {review.content}
                </Link>

            </div>
        )
    }
    else{
        return (
            <div>

            </div>
        )
    }

}
export default HistoryReplyCard